export interface GetGAuthStatusResponse {
  secretKey?: string;
  validationCode?: number;
  scratchCodes?: number[];
  smsAuthenticator?: boolean;
  validated?: boolean;
  emailAuthenticator?: boolean;
}

export interface EnableGAuthValidatedResponse {
  secretKey: string;
}

export interface ValidateGAuthResponse {
  valid: boolean;
}

export interface Validate2faEmailVerificationCodeRequest {
  token: string;
  forceSetEmailMfa?: boolean;
}

export interface Validate2faEmailVerificationCodeResponse {
  emailMfaSetToEnabled: boolean;
  memberEmailChangedTo?: string;
}

export interface Validate2faEmailVerificationCodeErrorResponseGeneric {
  message?: string;
}

export enum Validate2faEmailVerificationCodeErrorCode {
  INVALID_OR_EXPIRED_TOKEN = 'INVALID_OR_EXPIRED_TOKEN',
}

export type Validate2faEmailVerificationCodeErrorResponseWithCode =
  Validate2faEmailVerificationCodeErrorResponseGeneric & {
    message?: string;
    error: {
      code: Validate2faEmailVerificationCodeErrorCode;
    };
  };

export type Validate2faEmailVerificationCodeErrorResponse =
  | Validate2faEmailVerificationCodeErrorResponseGeneric
  | Validate2faEmailVerificationCodeErrorResponseWithCode;

export function isValidate2faEmailVerificationCodeErrorResponseWithCode(
  error: Validate2faEmailVerificationCodeErrorResponse
): error is Validate2faEmailVerificationCodeErrorResponseWithCode {
  return !!(error as Validate2faEmailVerificationCodeErrorResponseWithCode)?.error?.code;
}
